import * as Api from '@/request'

interface SmsNotifyDialog {
  visible: boolean
  type: number
  clientId: string
  module: string
}
interface SetDialogParams {
  visible: boolean
}
interface BatchTopic {
  topicId: number
  recordId: string | undefined
}
interface InviteDialogDataParams {
  clientId: string
  stage: number
  clear?: boolean
  topicId?: number
  recordId?: string
  batchTopic: Array<BatchTopic>
}
interface State {
  inviteDialogVisible: boolean
  diagnosisDialogVisible: boolean
  staffDialog: SetDialogParams
  recruitList: ListDataStruct
  staffList: ListDataStruct
  inviteData: InviteDataParams
  inviteDialogData: InviteDialogDataParams
  smsNotifyDialog: SmsNotifyDialog
  isRefreshList: boolean
}

interface ListDataStruct {
  list: Record<string, any>[]
  total: number
}

interface InviteDataParams {
  clientId: string
  topicId: number
  stage: number
  recordId: string
}

export default {
  namespaced: true,
  state: {
    inviteDialogVisible: false,
    diagnosisDialogVisible: false,
    inviteData: {
      clientId: '',
      topicId: 0,
      stage: 0,
      recordId: '',
    },
    // 组合邀约评估
    inviteDialogData: {
      clientId: '',
      stage: 0,
      batchTopic: [],
    },
    staffDialog: {
      visible: false,
    },
    recruitList: {
      list: [],
      total: 0,
    },
    staffList: {
      list: [],
      total: 0,
    },
    smsNotifyDialog: {
      visible: false,
      type: 0,
      clientId: '',
      module: 'assess',
    },
    isRefreshList: false,
  },
  getters: {},
  mutations: {
    // 设置短信dialog
    setSmsNotifyDialog(state: State, payload: SmsNotifyDialog) {
      state.smsNotifyDialog = {
        ...state.smsNotifyDialog,
        ...payload,
      }
    },
    setInviteDialogVisible(state: State, payload: boolean) {
      state.inviteDialogVisible = payload
      // 弹窗关闭时，还原数据
      !payload &&
        (state.inviteData = {
          clientId: '',
          topicId: 0,
          stage: 0,
          recordId: '',
        })
    },
    setDiagnosisDialogVisible(state: State, payload: boolean) {
      state.diagnosisDialogVisible = payload
    },
    setInviteData(state: State, payload: InviteDataParams) {
      state.inviteData = {
        ...state.inviteData,
        ...payload,
      }
    },
    setInviteDataDialog(state: State, payload: InviteDialogDataParams) {
      const { topicId, stage = 0, recordId, clientId, clear = false } = payload
      if (clientId !== undefined) {
        state.inviteDialogData.clientId = clientId
      }
      state.inviteDialogData.stage = stage
      const checked = state.inviteDialogData.batchTopic.find(
        (item) => item.topicId === topicId && item.recordId === recordId
      )
      if (topicId) {
        if (checked) {
          state.inviteDialogData.batchTopic = state.inviteDialogData.batchTopic.filter(
            (item) => !(item.topicId === topicId && item.recordId === recordId)
          )
        } else {
          state.inviteDialogData.batchTopic.push({ topicId, recordId })
        }
      }

      if (clear) {
        state.inviteDialogData.batchTopic = []
      }
    },
    setStaffDialog(state: State, payload: SetDialogParams) {
      state.staffDialog = payload
    },
    setRecruitList(state: State, payload: ListDataStruct) {
      payload.list = payload.list || []
      payload.total = payload.total || 0
      state.recruitList = payload
    },
    setStaffList(state: State, payload: ListDataStruct) {
      payload.list = payload.list || []
      payload.total = payload.total || 0
      state.staffList = payload
    },
    setIsRefreshList(state: State, payload: boolean) {
      state.isRefreshList = payload
    },
  },
  actions: {
    async getCandidateList({ commit }: any, params: any) {
      const data = await Api.getCandidateList(params)
      commit('setRecruitList', data)
    },
    async getCandidateListV2({ commit }: any, params: any) {
      const data = await Api.getCandidateListV2(params)
      commit('setRecruitList', data)
    },
    async getStaffList({ commit }: any, params: any) {
      const data = await Api.getStaffList(params)
      commit('setStaffList', data)
    },
    async getStaffListV2({ commit }: any, params: any) {
      const data = await Api.getStaffListV2(params)
      commit('setStaffList', data)
    },
  },
}
